// extracted by mini-css-extract-plugin
export default {"cls1":"UserCard-cls1_d1w","cls2":"UserCard-cls2_HR4 UserCard-cls1_d1w"};